import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import { getProjectDetails } from "../../api/casp/project";
import { toast } from "react-toastify";
import Loader from "../Common/Loader";
import { withTranslation } from "react-i18next";

const DashProgressBar = ({ projectId, source }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [projectDetails, setProjectDetails] = useState();

  useEffect(() => {
    if (projectId) {
      fetchProjectDetails();
    }
  }, []);

  const fetchProjectDetails = async () => {
    try {
      setIsLoading(true);
      const project = await getProjectDetails(projectId);
      setProjectDetails(project.data.data);
    } catch (error) {
      console.log(error);
      toast.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="dashProgressbar">
        {projectDetails && !isLoading && (
          <div>
            <div className="progressBarHeader d-flex justify-content-between">
              <h6>{source}</h6>
              <span>
                {projectDetails?.milestoneCount.totalCompletedMileStone}/
                {projectDetails?.milestoneCount.totalMilestone}
              </span>
            </div>
            <ProgressBar
              now={
                projectDetails?.milestoneCount?.totalMilestone
                  ? (projectDetails?.milestoneCount.totalCompletedMileStone /
                      projectDetails?.milestoneCount.totalMilestone) *
                    100
                  : 0
              }
              style={{ height: "8px", background: "#EBEDF5" }}
            />
          </div>
        )}
        {isLoading && <Loader />}
      </div>
    </React.Fragment>
  );
}

export default withTranslation()(DashProgressBar)
